<template>
  <div class="price-container">
    <!-- 价格组成说明 -->
    <div class="price-components">
      <div class="components-container">
        <div class="title">价格组成说明</div>
        <div class="desc">
          制作基础费用+定制版型费用+特殊工艺费用+面辅料费用+印花/绣花费用=总费用
        </div>
        <div class="list-box">
          <div class="list-item">
            <img
              src="../../../../assets/images/img-base-price.png"
              alt=""
              class="demo-img"
            />
            <div class="price-name">服装制作费></div>
          </div>
          <img
            src="../../../../assets/images/icon-plus.png"
            alt=""
            class="plus-ico"
          />
          <div class="list-item">
            <img
              src="../../../../assets/images/img-diy-price.png"
              alt=""
              class="demo-img"
            />
            <div class="price-name">定制版型费用></div>
          </div>
          <img
            src="../../../../assets/images/icon-plus.png"
            alt=""
            class="plus-ico"
          />
          <div class="list-item">
            <img
              src="../../../../assets/images/img-fm-price.png"
              alt=""
              class="demo-img"
            />
            <div class="price-name">面料/辅料费用></div>
          </div>
          <img
            src="../../../../assets/images/icon-plus.png"
            alt=""
            class="plus-ico"
          />
          <div class="list-item">
            <img
              src="../../../../assets/images/img-special-tech-price.png"
              alt=""
              class="demo-img"
            />
            <div class="price-name">特殊工艺费用></div>
          </div>
          <img
            src="../../../../assets/images/icon-plus.png"
            alt=""
            class="plus-ico"
          />
          <div class="list-item">
            <img
              src="../../../../assets/images/img-print-price.png"
              alt=""
              class="demo-img"
            />
            <div class="price-name">印花/绣花费用></div>
          </div>
          <img
            src="../../../../assets/images/icon-equal.png"
            alt=""
            class="plus-ico"
          />
          <div class="list-item">
            <img
              src="../../../../assets/images/img-base-price.png"
              alt=""
              class="demo-img"
            />
            <div class="price-name">总费用></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 举例说明 -->
    <div class="price-example">
      <div class="example-container">
        <div class="example-title">举例说明</div>
        <div class="example-desc">在线定制一件T恤的总费用详情如下</div>
        <div class="example-content">
            <img src="../../../../assets/images/img-example.png" alt="" class="left">
            <div class="right">
                <table>
                    <thead>
                        <tr>
                            <th>项目</th>
                            <th>规格说明</th>
                            <th>价格</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>品类制作费</td>
                            <td>T恤</td>
                            <td>¥40元</td>
                        </tr>
                        <tr>
                            <td>版型选择</td>
                            <td>平台现有版型</td>
                            <td>¥0元</td>
                        </tr>
                        <tr>
                            <td>面料选择</td>
                            <td>【平台面料】精棉牛肚大卫衣</td>
                            <td>¥51.45元</td>
                        </tr>
                        <tr>
                            <td>辅料选择</td>
                            <td>【自己提供辅料】</td>
                            <td>¥0元</td>
                        </tr>
                        <tr>
                            <td>特殊工艺选择</td>
                            <td>手工锁边</td>
                            <td>¥60元</td>
                        </tr>
                        <tr>
                            <td>印花工艺/个数</td>
                            <td>①面积:40x30CM 工艺:喷绘印花 印花色数:2色</td>
                            <td>¥30元</td>
                        </tr>
                        <tr>
                            <td>绣花工艺/个数</td>
                            <td>①面积:15x15CM 工艺:绣花直喷 绣花针数:12针</td>
                            <td>¥30元</td>
                        </tr>
                    </tbody>
                </table>
                <div class="total-wrap">
                    <div class="total-text">合计定制总费用:</div>
                    <div class="total-price">¥211.45</div>
                    <div class="total-price-unit">元/件</div>
                </div>
            </div>
        </div>
      </div>
    </div>
    <!-- 价格详情表 -->
     <div class="price-detail-list">
        <div class="list-container">
            <div class="detail-title">价格说明详情表</div>
            <div class="detail-list">
                <div class="left">
                    <div :class="['item',{active:curr_tab == item.value}]" v-for="(item,index) in left_tabs" :key="index" @click="curr_tab = item.value">
                        {{ item.name }}
                    </div>
                </div>
                <div class="right">
                    <div class="right-content">
                        <table>
                            <thead>
                                <tr v-if="curr_tab == '1'">
                                    <th>款式品类</th>
                                    <th>服装基础价格</th>
                                    <th>定制版型价格</th>
                                </tr>
                                <tr v-else>
                                    <th>工艺名称</th>
                                    <th>工艺价格</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="curr_tab == '1'">
                                    <tr v-for="(item,index) in list" :key="index">
                                        <td>{{ item.category_name_cn }}</td>
                                        <td>¥{{item.base_price || '0'}}元/件</td>
                                        <td><template v-if="item.making_price<=0||item.making_price_complex<=0">咨询报价</template><template v-else>¥{{`${item.making_price}~${item.making_price_complex}`}}元/件</template></td>
                                    </tr>
                                </template>
                                <template v-else-if="curr_tab == '2'">
                                    <tr v-for="(item,index) in list" :key="index">
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.price > 0 ? `¥${item.price}元/件`:'咨询报价' }}</td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr v-for="(item,index) in list" :key="index">
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.name.includes('升华') ? '咨询报价' : `¥${item.price_range}元/件` }}</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
     </div>
  </div>
</template>
<script>
import { getPriceList } from '@/api/index';
export default {
  name: "PriceIntroduction",
  data() {
    return {
        left_tabs:[
            {name:'品类制作费',value:'1'},
            {name:'特殊工艺费用',value:'2'},
            {name:'印花工艺价格',value:'3'},
            {name:'绣花工艺价格',value:'4'}
        ],
        curr_tab:'1',
        list:[]
    };
  },
  watch:{
    curr_tab(news,olds){
        if(news != olds){
            this.onGetList();
        }
    }
  },
  mounted() {
    this.onGetList();
  },
  methods: {
    async onGetList(){
        try{
            const {data} = await getPriceList({type:this.curr_tab});
            this.list = data;
        }catch(e){
            console.log('price-list-err',e);
        }
    }
  },
};
</script>
<style lang="scss" scoped>
.price-container {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  .price-components {
    width: 1280px;
    background: #ffffff;
    border-radius: 20px;
    margin-top: 30px;
    .components-container {
      padding: 40px 40px 32px 40px;
      .title {
        color: #000000;
        font-size: 20px;
        font-weight: bold;
        width: 100%;
        text-align: center;
      }
      .desc {
        color: #808080;
        font-size: 14px;
        margin-top: 16px;
        width: 100%;
        text-align: center;
      }
      .list-box {
        width: 100%;
        display: flex;
        align-items: center;
        margin-top: 32px;
        .list-item {
          width: 13.59%;
          // height:220px;
          background: #ffffff;
          border-radius: 15px;
          box-shadow: 2px 0px 5px 0px #e6e6e6;
          border: 2px solid #ffffff;
          .demo-img {
            width: 100%;
            height: 156px;
            border-top-left-radius: 15px;
            border-top-right-radius: 15px;
          }
          .price-name {
            color: #333333;
            font-size: 15px;
            text-align: center;
            padding: 10px 0;
          }
        }
        .plus-ico {
          width: 32px;
          height: 32px;
          margin: 0 10px;
        }
      }
    }
  }
  .price-example {
    width: 1280px;
    background: #ffffff;
    border-radius: 20px;
    margin-top: 20px;
    .example-container {
      padding: 30px 40px 60px 40px;
      .example-title {
        color: #000000;
        font-size: 20px;
        font-weight: bold;
        text-align:center;
      }
      .example-desc {
        color: #808080;
        font-size: 14px;
        margin-top: 15px;
        padding-bottom: 25px;
        border-bottom: 1px solid #dee0e3;
        text-align:center;
      }
      .example-content{
        width:100%;
        display:flex;
        // justify-content:space-between;
        column-gap:40px;
        margin-top:35px;
        height:571px;
        .left{
            width:45%;
            height:100%;
        }
        .right{
            flex:1;
            // height:100%;
            table{
                width:100%;
                // height:100%;
                border-collapse:collapse;
                text-align:center;
                thead{
                    background:#f2f3f8;
                    height:60px;
                    tr{
                        th{
                            font-weight:bold;
                            color:#000000;
                            font-size:16px;
                        }
                        th:first-child {
                            border-radius:5px 0 0 0;
                        }
                        th:last-child {
                            border-radius:0 5px 0 0;
                        }
                    }
                }
                tbody {
                    tr {
                        height:60px;
                        border-bottom: 1px dashed #dee0e3;
                        td{
                            font-size:14px;
                        }
                        td:first-child{
                            text-align:left;
                            padding-left:20px;
                        }
                    }
                }
            }
            .total-wrap{
                margin-top:40px;
                width:100%;
                display:flex;
                justify-content:flex-end;
                align-items: baseline;
                .total-text{
                    color:#000000;
                    font-size:14px;
                    font-weight:bold;
                }
                .total-price{
                    color:#ff3e04;
                    font-size:24px;
                    font-weight:bold;
                }
                .total-price-unit{
                    color:#000000;
                    font-size:14px;
                }
            }
        }
      }
    }
  }

  .price-detail-list{
    width:1280px;
    margin-top:20px;
    background:#ffffff;
    border-radius:20px;
    margin-bottom:85px;
    .list-container{
        padding:40px 40px 50px 40px;
        .detail-title{
            width:100%;
            text-align:center;
            color:#000000;
            font-size:20px;
            font-weight:bold;
            position:relative;
            &::after{
                content:"";
                display:block;
                border-bottom:4px solid #fa3d5a;
                width:53px;
                position:absolute;
                left:50%;
                bottom:-15px;
                transform:translateX(-50%);
            }
        }
        .detail-list{
            width:100%;
            border:1px solid #dcd0e0;
            border-radius:15px;
            overflow:hidden;
            margin-top:50px;
            display:flex;
            align-self: stretch;
            .left{
                width:150px;
                // height:100%;
                display:flex;
                flex-direction: column;
                background:#f2f3f8;
                padding:40px 0 0 10px;
                .item{
                    width:100%;
                    height:60px;
                    line-height:60px;
                    font-size:16px;
                    color:#000000;
                    text-align:center;
                    flex-shrink:0;
                    cursor:pointer;
                    &.active, &:hover{
                        background:#ffffff;
                        border-radius:10px 0 0 10px;
                        color:#fa3d5a;
                        font-weight:bold;
                    }
                }
            }
            .right{
                flex:1;
                height:100%;
                .right-content{
                    padding:30px 40px 40px 40px;
                    table{
                        width:100%;
                        border-collapse: collapse;
                        text-align:center;
                        thead{
                            color:#666666;
                            font-size:16px;
                            font-weight:bold;
                            tr th{
                                padding-bottom:22px;
                                border-bottom:1px solid rgba(0,0,0,0.2);
                            }
                        }
                        tbody{
                            tr{
                                height:55px;
                                border-bottom:1px dashed rgba(0,0,0,0.2);
                                td:first-child{
                                    color:#000000;
                                    font-weight:bold;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
  }
}
</style>
